import { UnauthenticatedPage } from "Components/Pages/UnauthenticatedPage";
import { observer } from "mobx-react";
import React from "react";

import { Spinner } from "@fluentui/react-components";

interface LoadingPageProps {
    label?: string;
}
const LoadingPageBase = ({ label }: LoadingPageProps) => (
    <UnauthenticatedPage content={<Spinner label={label} size="large" aria-busy="true" aria-label="Loading Content" />} />
);

export const LoadingPage = observer(LoadingPageBase);
